export const LEFT_MAIN_MENU_ITEMS = {
    PAGES: 'pages',
    THEMES: 'themes',
    MANAGE: 'manage',
    ASSETS: 'assets'
};

export const MENU_ITEMS_ASSETS = {
    IMAGES: 'images',
    CUSTOMIZATION: 'customization',
    TRACKING: 'tracking',
    CUSTOMFONTS: 'customFonts',
    OTHER: 'other'
};



// WEBPACK FOOTER //
// ./src/constants/MenuItems.js